import { Badge, Icons } from '@commenda/kakashi';
import { classNames } from '@commenda/utils';
import { IncorporationRequestStatus } from '@prisma/client';
import { WorkFlowProcessDrawerParentSteps } from './types';

const WorkflowProcessParentStep = ({
  isActive,
  step,
  onClick,
}: {
  isActive: boolean;
  step: WorkFlowProcessDrawerParentSteps;
  onClick: () => void;
}) => {
  const statusToVariant = {
    [IncorporationRequestStatus.Completed]: 'success',
    [IncorporationRequestStatus.InProgress]: 'warning',
    ReviewPending: 'warning',
    Replaced: 'warning',
    Verified: 'success',
    Signed: 'success',
    NotSigned: 'gray',
    IssueReported: 'error',
    ActionRequired: 'error',
    // Default case
    default: 'gray',
  };

  // Define a mapping for status to display text
  const statusToText = {
    [IncorporationRequestStatus.Completed]: 'Completed',
    [IncorporationRequestStatus.InProgress]: 'In progress',
    ReviewPending: 'Review pending',
    Replaced: 'Replaced',
    Verified: 'Verified',
    Signed: 'Signed',
    NotSigned: 'Not signed',
    IssueReported: 'Issue reported',
    ActionRequired: 'Action required',
    // Default case
    default: 'Not started',
  };
  return (
    <div
      onClick={onClick}
      className={classNames(
        'border-r-[6px] py-4  px-5 hover:bg-bg-primary-hover transition cursor-pointer flex flex-col gap-2 border-b border-b-border-primary',
        isActive
          ? 'border-fg-tertiary bg-bg-primary-hover'
          : 'border-[rgba(0,0,0,0)] bg-bg-primary'
      )}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span
            className={classNames(
              'text-text-tertiary txt-medium-regular',
              isActive && 'txt-medium-bold'
            )}
          >
            {step.heading}
          </span>
          {step.status === 'Replaced' && (
            <Icons.InfoCircle className="h-5 w-5 text-fg-warning-hover" />
          )}
        </div>

        <Badge
          variant={statusToVariant[step.status] || statusToVariant.default}
        >
          {statusToText[step.status] || statusToText.default}
        </Badge>
      </div>
      {step.description && (
        <p className="text-text-secondary txt-small-regular">
          {step.description}
        </p>
      )}
    </div>
  );
};

export { WorkflowProcessParentStep };
